import React from "react";
import { useDrag } from "react-dnd";
import TagIcon from "./TagIcon";

const Tag = ({ tag, source, moveTag, categoryId, sameTagsClickHandler, userTags, canManageCategories = true }) => {
  const [{ isDragging }, drag] = useDrag(() => ({
    type: "tag",
    canDrag: () => !!canManageCategories,
    item: { id: tag._id, source, cid: categoryId, tag: tag },
    end: (item, monitor) => {
      const dropResult = monitor.getDropResult();
      if (item && dropResult && item.source !== dropResult.category) {
        moveTag({
          userTags,
          tagId: item.id,
          tag: item.tag,
          source: item.source,
          fromCid: item.cid,
          toCid: dropResult.cid,
        });
      }
    },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  }), [userTags, categoryId, source, tag, canManageCategories]);

  return (
    <div ref={drag} style={{ opacity: isDragging ? 0.5 : 1 }}>
      <TagIcon name={tag.label} id={tag._id} count={tag.count} sameTagsClickHandler={sameTagsClickHandler} />
    </div>
  );
};

export default Tag;
